import { ChatState } from "PFApp/components/chat/chat_states";
import { useEffect, useRef, useState } from "react";

import { ChatMessagesData } from "./chat_types";

export const useChatDropdown = (
  chatState: ChatState,
  messages: ChatMessagesData | undefined,
  minimized: boolean
) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownFocusRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    dropdownFocusRef.current?.addEventListener("blur", () => setDropdownOpen(false));
  }, [chatState, messages, minimized]);

  useEffect(() => {
    dropdownFocusRef.current?.focus();
  }, []);

  return { dropdownOpen, setDropdownOpen, dropdownFocusRef };
};
